import {
  ChangeDetectionStrategy,
  Component,
  CUSTOM_ELEMENTS_SCHEMA,
  inject,
  signal,
} from '@angular/core';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import {
  IonButton,
  IonContent,
  IonIcon,
  IonLabel,
  IonSegment,
  IonSegmentButton,
  ModalController,
  Platform,
} from '@ionic/angular/standalone';
import { addIcons } from 'ionicons';
import { logoApple, logoChrome, logoFirefox } from 'ionicons/icons';

@Component({
  templateUrl: './tutorial.component.html',
  styleUrls: ['./tutorial.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [
    FontAwesomeModule,
    IonContent,
    IonSegment,
    IonSegmentButton,
    IonLabel,
    IonIcon,
    IonButton,
  ],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class TutorialComponent {
  public readonly segment = signal<number>(0);
  private readonly modalController = inject(ModalController);
  private readonly platform = inject(Platform);

  public constructor() {
    addIcons({ logoChrome, logoApple, logoFirefox });
    if (this.platform.is('ios')) {
      this.segment.set(2);
    } else if (this.platform.is('android')) {
      // @ts-expect-error: InstallTrigger
      if (typeof InstallTrigger !== 'undefined') {
        this.segment.set(1);
      } else {
        this.segment.set(0);
      }
    }
  }

  public dismiss(): void {
    void this.modalController.dismiss().then();
  }

  public segmentChanged(event: CustomEvent): void {
    this.segment.set(Number(event.detail.value));
    event.stopPropagation();
  }
}
